module.exports = __webpack_public_path__ + "img/notive.3def6ee5.svg";